const responsiveFontSize = px => ((px / 16) * 1.486).toFixed(3) + 'rem'

export default responsiveFontSize